import { render } from "./404-basic.vue?vue&type=template&id=425d9b9f"
import script from "./404-basic.vue?vue&type=script&lang=js"
export * from "./404-basic.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__